import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { get, post } from '../../utils/api';
import { Form, FormInput } from '../common/Form';
import { genPassword } from '../../utils/genPassword';

const UserAdd = () => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const auth = useSelector(state => state.auth.user);
	const navigate = useNavigate();
	const [ name, setName ] = useState('');
	const [ role, setRole ] = useState('exhibitor');
	const [ limit, setLimit ] = useState('0');
	const [ email, setEmail ] = useState('');
	const [ event, setEvent ] = useState('');
	const [ eventList, setEventList ] = useState([]);
    const [ password, setPassword ] = useState(genPassword(10));
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
    const [ success, setSuccess ] = useState('');

	const roleList = [{
			value: 'root',
			text: t('user.root'),
			disabled: auth.role !== 'root',
		}, {
			value: 'admin',
			text: t('user.admin'),
			disabled: auth.role !== 'root',
		}, {
			value: 'exhibitor',
			text: t('user.exhibitor'),
		}, {
			value: 'agent',
			text: t('user.agent'),
		}];

	// Запрашиваем список доступных пользователю мероприятий.
	// Для root доступны все мероприятия, для admin только те, к которым он привязан.
	useEffect(() => {
		const fetchData = async () => {
			const method = auth.role === 'root' ? '/events' : '/a2e';
			const params = auth.role === 'root' ? {} : { admin: auth._id };
			const result = await get(method, params);
			if(result.error) {
				setEventList([]);
			} else {
				const list = [];
				const data = auth.role === 'root' ? result.data.events : result.data.a2e;
				data.forEach(item => {
					const event = auth.role === 'root' ? item : item.event;
					list.push({ value: event._id, text: event.name[lang] });
				});
				setEventList(list);
			}
		}
		fetchData();
	}, [ auth, lang ]);

	// Отправка данных
	const onSubmit = async () => {
        setIsLoading(true);
        setError('');
        setSuccess('');
        const result = await post('/users', { name, role, email, password, event, lang, limit: parseInt(limit) });
        if(result.error) {
            setError(result.error);
        } else {
            setSuccess('useradd.success_' + role);
			navigate('/cabinet/userview/' + result.data.user._id + '/action/created');
        }
        setIsLoading(false);
	};

	const onChangeLimit = (limit) => {
		if(!limit) setLimit('');
		else if(/^\d+$/.test(limit)) setLimit(limit);
	};

	return (
		<div>
	    	<h1>{t('useradd.title_' + role)}</h1>
			{isLoading ? <span>{t('loader.title')}</span> :
			<Form
				success={success}
				error={error}
				info={'useradd.subtitle_' + role}
				submit={'useradd.submit_' + role}
				onSubmit={onSubmit}
			>
				<FormInput
					id='role'
					type='select'
					value={role}
					onChange={setRole}
					label={t('user.role')}
					required={true}
					list={roleList}
					hint={t('useradd.role')}
				/>
				<FormInput
					id='name'
					type='text'
					value={name}
					onChange={setName}
					label={t('useradd.name_' + role)}
					placeholder={t('useradd.name_' + role)}
					required={true}
				/>
				<FormInput
					id='email'
					type='text'
					value={email}
					onChange={setEmail}
					label={t('user.email')}
					placeholder={t('user.email')}
					required={true}
				/>
				<FormInput
					id='password'
					type='text'
					value={password}
					onChange={setPassword}
					label={t('user.password')}
					required={true}
				/>
				<strong
					onClick={() => setPassword(genPassword(10))}
					style={{
						cursor: 'pointer',
						userSelect: 'none',
						color: 'var(--main-color)',
                        textAlign: 'right',
					}}
				>
					{t('useradd.password_hint')} <Icon icon={faRotate}/>
				</strong>

				{role !== 'root' &&
				<FormInput
					id='event'
					type='select'
					value={event}
					onChange={setEvent}
					required={true}
					label={t('useradd.event')}
					hint={t('useradd.event_hint')}
					list={eventList}
				/>}

				{(role === 'agent' && auth.role === 'root') &&
				<FormInput
					id='limit'
					type='text'
					value={limit}
					onChange={onChangeLimit}
					label={t('useradd.limit')}
					required={true}
				/>}
			</Form>}
		</div>
	);
};

export default UserAdd;
